/**
 * The consent checkboxes shown on the last step of the investor LAFT form.
 *
 * They live here because the last step is not always the same one: with the
 * early-deposit flag off the form ends on investigaciones (step 4), and with it
 * on the form ends on the ID copies (step 5). Both templates render these, so
 * the copy and the contract URL must exist in exactly one place.
 */
export const LAFT_FORM_CONSENTS = {
  CONTRACT:
    '<span>He leído y acepto el <a class="bold-600 blue" href="https://storage.googleapis.com/finsmart-websitefiles/legal/Contrato%20del%20inversionista%20v3.2.docx.pdf" target="_blank">Contrato de Inversionista</a>.</span>',
  COMMERCIAL_USE:
    '<span>Acepto que mis datos proporcionados en el formulario PLAFT puedan ser utilizados para fines comerciales, conforme a la política de privacidad vigente.</span>',
  DECLARATION_NOTICE:
    'La información que completes en este formulario será tomada como una declaración jurada. La usaremos para cumplir con nuestros procesos de validación (conocer a nuestros clientes) y para generar tu contrato con Finsmart.',
} as const;

/**
 * One message for every way the ID check can fail — unreadable image, wrong number,
 * provider error. Which of them occurred is deliberately not disclosed: telling the
 * investor "the number does not match" tells someone probing with another person's
 * document that the image was read successfully.
 */
export const LAFT_ID_COPY_VALIDATION_ERROR =
  'No pudimos validar tu documento de identidad. Verifica que la imagen sea legible y corresponda al documento que registraste.';
